import { render, staticRenderFns } from "./Roll.vue?vue&type=template&id=e679fa2e&scoped=true&"
import script from "./Roll.vue?vue&type=script&lang=js&"
export * from "./Roll.vue?vue&type=script&lang=js&"
import style0 from "./Roll.vue?vue&type=style&index=0&id=e679fa2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e679fa2e",
  null
  
)

export default component.exports